import React from "react";
import RecapSlides from "./RecapSlides";
import RecapScontrino from "./RecapScontrino";

const Ricapitolando = ({
  parameters,
  fatturato,
  contributi,
  imposteTotali,
  netto,
}) => {
  return (
    <>
      <h2 className="font-bold text-md px-4 pb-0 md:pb-2 text-xl md:text-3xl">
        Ricapitolando
      </h2>
      <div className="grid lg:grid-cols-2 gap-x-4">
        <RecapSlides
          professioneId={parameters.professione}
          riduzioneImposte={parameters.riduzioneImposte}
        />
        <RecapScontrino
          fatturato={fatturato}
          contributi={contributi}
          imposteTotali={imposteTotali}
          netto={netto}
        />
      </div>
    </>
  );
};

export default Ricapitolando;
